import type { CampaignEditorReducerCreator } from './types';
import loadCampaignEditor from './reducers/load-campaign-editor';
import selectCampaignTemplate from './reducers/select-campaign-template';
import resetCampaignEditor from './reducers/reset-campaign-editor';
import setCampaignEditorField from './reducers/set-campaign-editor-field';
import setCampaignEditorBlocksForTemplate from './reducers/set-campaign-editor-blocks-for-template';
import setCampaignEditorTemplateMounted from './reducers/set-campaign-editor-template-mounted';
import setSelectedBlockId from './reducers/set-selected-block-id';
import insertBlock from './reducers/insert-block';
import updateBlockValue from './reducers/update-block-value';
import updateBlockImage from './reducers/update-block-image';
import updateBlockProp from './reducers/update-block-prop';
import updateBlockStyle from './reducers/update-block-style';
import moveBlock from './reducers/move-block';
import reorderBlocks from './reducers/reorder-blocks';
import deleteBlock from './reducers/delete-block';

export const reducers = (create: CampaignEditorReducerCreator) => ({
  // seeds the editor from the stored email, for the language being edited
  loadCampaignEditor: loadCampaignEditor(create),

  // the new template's layout and defaults, but the copy and uploads the user authored carry
  // across - and the defaults land in every language the campaign carries rather than writing the
  // english ones into whichever language is being edited. Patched with the templateId in one go,
  // because patchScheduledEmailCustomizations drops the blocks when the template changes without
  // them, and the user's content with it.
  selectCampaignTemplate: selectCampaignTemplate(create),

  resetCampaignEditor: resetCampaignEditor(create),
  setCampaignEditorField: setCampaignEditorField(create),
  setCampaignEditorBlocksForTemplate: setCampaignEditorBlocksForTemplate(create),
  setCampaignEditorTemplateMounted: setCampaignEditorTemplateMounted(create),
  setSelectedBlockId: setSelectedBlockId(create),
  insertBlock: insertBlock(create),
  updateBlockValue: updateBlockValue(create),
  updateBlockImage: updateBlockImage(create),
  updateBlockProp: updateBlockProp(create),
  updateBlockStyle: updateBlockStyle(create),
  moveBlock: moveBlock(create),
  reorderBlocks: reorderBlocks(create),
  deleteBlock: deleteBlock(create),
});
